import React from 'react';
import SearchContainer from 'search/SearchContainer';

const SectionHeader = ({ title, mq, isMobile }) => {
    const searchContainerEl = (mq !== 'mobile' && !isMobile) ? <SearchContainer /> : null;
    return (
        <header className="section-header">
            <h1 className="section-header_title">{title}</h1>
            {searchContainerEl}
        </header>
    );
};

SectionHeader.propTypes = {
    title: React.PropTypes.string,
    isMobile: React.PropTypes.bool,
    mq: React.PropTypes.string
};

export default SectionHeader;



// WEBPACK FOOTER //
// ./app/schedule/SectionHeader.js